<template>
    <div class="banner">
        <div class="spinner-border text-primary" role="status" v-if="isLoading && pics?.length">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="owl-carousel" v-if="pics?.length" ref="carousel">
            <div class="showpiece-banner" v-for="pic in pics" :key="pic.id">
                <img :src="pic.url['w0h0']" alt="" title="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Banner',
    props: {
        pics: {
            type: Array,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: [],
        },
    },
    data() {
        return {
            isLoading: false,
        };
    },
    mounted() {
        // if (this?.pics?.length > 0) {
        //     this.initOwlCarousel();
        //     this.isLoading = false;
        // } else {
        //     this.isLoading = false;
        // }
    },
    methods: {
        // initOwlCarousel() {
        //     $(this.$refs.carousel).owlCarousel({
        //         autoplay: true, // 自動撥放
        //         autoplayTimeout: 6000,
        //         autoplayHoverPause: true,
        //         loop: true, // 圖片循環
        //         center: false, // 是否置中
        //         navText: [], // 箭頭預設文字消失
        //         nav: false, // 前後箭頭
        //         dot: true,
        //         items: 1,
        //     });
        // },
    },
};
</script>
<style scoped lang="scss">
.spinner-border{
    margin: 50px 50%;
}
</style>
